import { cn } from "@/lib/utils";

interface StatusCodeProps {
  statusCode: number;
  className?: string;
}

function getStatusCodeColor(statusCode: number): string {
  if (statusCode >= 200 && statusCode < 300) {
    return "text-success";
  }
  if (statusCode >= 300 && statusCode < 400) {
    return "text-info";
  }
  if (statusCode >= 400 && statusCode < 500) {
    return "text-warning";
  }
  if (statusCode >= 500) {
    return "text-danger";
  }
  return "text-neutral-500";
}

export function StatusCode({ statusCode, className }: StatusCodeProps) {
  return (
    <span className={cn(getStatusCodeColor(statusCode), className)}>
      {statusCode}
    </span>
  );
}
